<template>
	<div class="invoice-detail">

		<van-form @submit="send">
			<div class="page-title">申请发票</div>

			<van-cell title="抬头类型" class="title">
				<template #label>
					<van-tabs type="card" v-model="ruleForm.type" class="field" @change="typeChange">
						<van-tab title="个人抬头" name="personal"></van-tab>
						<van-tab title="单位抬头" name="company"></van-tab>
					</van-tabs>
				</template>
			</van-cell>

			<van-cell title="抬头名称" class="title required">
				<template #label>
					<van-field v-model="ruleForm.name"
					:rules="[{ required: true, message: '请填写抬头名称' }]"
					placeholder="抬头名称"
					class="field">
						<template #button>
							<van-icon name="coupon-o" class="icon" size="24px" @click="setTitle = true" />
						</template>
					</van-field>
				</template>
			</van-cell>

			<van-cell title="发票金额" class="title" v-if="queryOrderNo.length > 0">
				<template #label>
					<span class="field" style="color: #ee0a24">{{invoice_amount}}</span>
				</template>
			</van-cell>

			<van-cell title="开票金额" class="title required" v-if="queryOrderNo.length <= 0">
				<template #label>
					<van-field v-model="ruleForm.total_amount"
						type="number"
						:rules="[
							{ required: true, message: '请输入开票金额' },
							{ validator: validatorAmount, message: validatorAmountMsg }]"
						placeholder="开票金额"
						class="field">
					</van-field>
				</template>
			</van-cell>

			<van-cell title="开票站点" class="title required" v-if="queryOrderNo.length <= 0">
				<template #label>
					<van-field
						:value="displaySiteName"
						readonly clickable
						:rules="[{ required: true, message: '请选择站点' }]"
						placeholder="选择站点"
						@click="showSite = true"
						class="field">
					</van-field>
				</template>
			</van-cell>

			<van-cell title="开票油品" class="title required" v-if="queryOrderNo.length <= 0">
				<template #label>
					<van-field
						:value="displayOilName"
						readonly clickable
						:rules="[{ required: true, message: '请选择油品' }]"
						placeholder="选择油品"
						@click="showOil = true"
						class="field">
					</van-field>
				</template>
			</van-cell>

			<div v-if="ruleForm.type === 'company'">

				<van-cell title="纳税人识别号" class="title required">
					<template #label>
						<van-field v-model="ruleForm.taxpayer_no"
						:rules="[{ required: true, message: '请填写纳税人识别号' }]"
						placeholder="纳税人识别号"
						class="field" />
					</template>
				</van-cell>

				<van-cell title="企业地址" class="title">
					<template #label>
						<van-field v-model="ruleForm.business_address"
						placeholder="企业地址"
						class="field" />
					</template>
				</van-cell>

				<van-cell title="电话" class="title">
					<template #label>
						<van-field v-model="ruleForm.business_telephone"
						placeholder="电话"
						class="field" />
					</template>
				</van-cell>

				<van-cell title="开户行" class="title">
					<template #label>
						<van-field v-model="ruleForm.bank_of_deposit"
						placeholder="开户行"
						class="field" />
					</template>
				</van-cell>

				<van-cell title="银行账号" class="title">
					<template #label>
						<van-field v-model="ruleForm.bank_account"
						placeholder="银行账号"
						class="field" />
					</template>
				</van-cell>
			</div>

            <van-cell title="开票种类" class="title required" v-if="ruleForm.invoice_type === 'electron'">
                <template #label>
                    <van-field
                        :value="displayInvoiceOrderType"
                        readonly clickable
                        :rules="[{ required: true, message: '请选择开票种类' }]"
                        placeholder="请选择开票种类"
                        @click="showInvoiceOrderType = true"
                        class="field">
                    </van-field>
                </template>
            </van-cell>

			<van-cell title="手机号" class="title">
				<template #label>
					<van-field v-model="ruleForm.phone"
					placeholder="手机号"
					class="field" />
				</template>
			</van-cell>

            <van-cell title="邮箱" class="title">
                <template #label>
                    <van-field v-model="ruleForm.email"
                               placeholder="邮箱"
                               class="field" />
                </template>
            </van-cell>

			<van-cell title="申请纸质发票" class="title" @click="disableMsg">
				<template>
					<van-switch
						v-model="ruleForm.invoice_type"
						active-value="paper"
						inactive-value="electron"
						active-color="#ee0a24"
						inactive-color="#dcdee0"
						size="24"
						:disabled="!isElectronInvoiceEnable || !isPaperInvoiceEnable"
					/>
				</template>
			</van-cell>

			<van-cell title="备注" class="title">
				<template #label>
					<van-field v-model="ruleForm.remarks"
					placeholder="请输入备注"
					class="field" />
				</template>
			</van-cell>

			<div v-if="ruleForm.invoice_type === 'paper'" class="show">
				<van-cell title="获取发票方式" class="title" @click="disableMethodMsg">
					<template>
						<div style="display: flex; align-items: center;float: right;">
							<span class="switch-text">邮寄</span>
							<van-switch
								v-model="ruleForm.paper_get_invoice_method"
								active-value="scene"
								inactive-value="post"
								active-color="#ee0a24"
								inactive-color="#ee0a24"
								size="24"
								:disabled="!isPostEnable || !isSceneEnable"
							/>
							<span class="switch-text">现场</span>
						</div>
					</template>
				</van-cell>
			</div>

			<div v-if="ruleForm.invoice_type === 'paper' && ruleForm.paper_get_invoice_method === 'post'" class="show">

				<van-cell title="收件人" class="title required">
					<template #label>
						<van-field v-model="ruleForm.receive_name"
						:rules="[{ required: true, message: '请填写收件人' }]"
						placeholder="收件人"
						class="field" />
					</template>
				</van-cell>

				<van-cell title="收件人手机号" class="title required">
					<template #label>
						<van-field v-model="ruleForm.receive_phone"
						:rules="[{ required: true, message: '请填写收件人手机号' }]"
						placeholder="收件人手机号"
						class="field" />
					</template>
				</van-cell>

				<van-cell title="收件人城市" class="title required" @click="showArea = true" is-link>
					<template #label>
						<span class="field" style="color: #333">{{ruleForm.receive_province}} {{ruleForm.receive_city}} {{ruleForm.receive_district}}</span>
					</template>
				</van-cell>

				<van-cell title="收件地址" class="title required">
					<template #label>
						<van-field v-model="ruleForm.receive_address"
						:rules="[{ required: true, message: '请填写收件地址' }]"
						placeholder="收件地址"
						class="field" />
					</template>
				</van-cell>

			</div>


			<van-popup v-model="showArea" round position="bottom">
				<van-area title="选择城市"
					:area-list="areaList"
					@confirm="setReceiveArea"
					@cancel="showArea = false"
				/>
			</van-popup>

			<van-popup v-model="setTitle" round position="bottom" class="set-title">
				<van-nav-bar
					title="预设抬头"
					left-text="转至编辑"
					right-text="返回"
					@click-left="$router.push({ name : 'InvoiceTitleInfo'})"
					@click-right="setTitle = false"
				/>
				<van-pull-refresh v-model="refreshLoading" @refresh="onRefresh" class="invoice_list-container">
					<van-empty v-if="!invoiceList.length" description="没有开票信息" />
					<van-list
						v-model="listLoading"
						:finished="finished"
						loading-text="..."
						@load="onLoad"
						>
							<div class="invoice-item-container title-cell"
								v-for="(item, index) in invoiceList"
								:key="'invoice-item' + index"
								@click="settingInvoiceTitle(item)"
								>
								<van-cell class="invoice-item-card invoice_id">
									<template #title>
										<div class="invoice-item-headline">
											<span class="sub-title">{{invoiceTypes[item.type]}}抬头</span>
											<span>{{item.name}}</span>
										</div>
									</template>
								</van-cell>
							</div>
					</van-list>
				</van-pull-refresh>
			</van-popup>

			<van-popup v-model="showSite" round position="bottom">
				<van-picker
					show-toolbar
					:columns="quotaInfoWithMax"
					@confirm="setSite"
					value-key="text"
					@cancel="showSite = false"
				/>
			</van-popup>

			<van-popup v-model="showOil" round position="bottom">
				<van-picker
					show-toolbar
					:columns="OilTypes"
					@confirm="setOil"
					value-key="name"
					@cancel="showOil = false"
				/>
			</van-popup>

            <van-popup v-model="showInvoiceOrderType" round position="bottom">
                <van-picker
                    show-toolbar
                    :columns="invoiceOrderTypeArr"
                    @confirm="setInvoiceOrderType"
                    value-key="name"
                    @cancel="showInvoiceOrderType = false"
                />
            </van-popup>

			<!-- 执行参数设置 -->
			<div v-show="false" :a="isPaperOnly" :b="isElectronOnly" :c="isPostOnly" :d="isSceneOnly"></div>
			<div style="display: flex; justify-content: center; padding:0.6rem 0;">
				<van-button type="danger" round class="SubmitBtn" native-type="submit">提交</van-button>
			</div>
		</van-form>
	</div>
</template>

<script>
    import api from "../../assets/js/api";
	import { areaList } from '@vant/area-data';

    export default {
        name: "Invoice",
        data(){
            return {
				areaList: areaList,
				showArea: false,
                isLoading: false,
                ruleForm: {
					order_no: '',
					invoice_type: 'electron',
                    invoice_order_type: '',
					type: 'company',
					name: '',
					phone: '',
                    email: '',
					taxpayer_no: '',
					business_address: '',
					business_telephone: '',
					bank_of_deposit: '',
					bank_account: '',
					remarks: '',
					paper_get_invoice_method: 'post',
					site_id: '',
					oil_type_id: '',
					total_amount: '',
                },
                cacheTypeInfo: {
                    company: null,
                    personal: null,
                },
                id: '',
				invoice_amount: 0,
				setTitle: false,
                refreshLoading: false, //刷新中
				listLoading: false, // 加载中
                invoiceList: [],
				finished: false,
                requestIsLock: false, // 请求锁
				params: {
                    page: 1,
                    pageSize: 10
                },
				previewType: 'electron',
				quotaInfo: [],
				showSite: false,
				showOil: false,
                showInvoiceOrderType: false,
				maxQuota: 0,
                siteAllowInvoiceTypeArr: {},
                allowInvoiceTypeArr: {},
            };
        },
        created() {
            let self = this;
			this.isLoading = true;
			this.ruleForm.order_no = self.queryOrderNo;
			let loading = this.$toast.loading({
				message: '加载中...',
				forbidClick: true,
				loadingType: 'spinner',
				duration: 0,
			});
			api.request('/invoice/preview', {
				'order_no' : self.queryOrderNo,
			}).then(res => {
				if (res.data.recently_invoice_info) {
					self.previewType = res.data.recently_invoice_info.invoice_type;
					// 清除部分参数, 本地系统限制优先级大于接口
					delete res.data.recently_invoice_info.invoice_type;
					delete res.data.recently_invoice_info.paper_get_invoice_method;
					if (res.data.recently_invoice_info) {
						self.ruleForm = {...self.ruleForm, ...res.data.recently_invoice_info};
					}
				}

				self.invoice_amount = res.data.invoice_amount;
				self.quotaInfo = res.data.invoice_quota;
                self.siteAllowInvoiceTypeArr = res.data.site_allow_invoice_type_arr;
                self.allowInvoiceTypeArr = res.data.allow_invoice_type_arr;
				if (self.queryOrderNo.length <= 0) {
					self.ruleForm.site_id = self.quotaInfo[0].id;
					self.ruleForm.total_amount = self.quotaInfo[0].quota;
					self.maxQuota = self.quotaInfo[0].quota;
				}
			}).finally(() => {
				self.isLoading = false;
				self.$toast.clear(loading);
			})
        },
		computed: {
			invoiceTypes() {
				return this.$store.state.systemEnum.company.user_invoice_info.type
			},
			isElectronInvoiceEnable() {
				return this.$store.state.systemConfig['invoice.is_electron_invoice_enable']
			},
			isPaperInvoiceEnable() {
				return this.$store.state.systemConfig['invoice.is_paper_invoice_enable']
			},
			isPaperOnly() {
				if (!this.isElectronInvoiceEnable && this.isPaperInvoiceEnable) {
					this.ruleForm.invoice_type = 'paper'
					return true
				}
				return false
			},
			isElectronOnly() {
				if (this.isElectronInvoiceEnable && !this.isPaperInvoiceEnable) {
					this.ruleForm.invoice_type = 'electron'
					return true
				}
				return false
			},
			isPostEnable() {
				return this.$store.state.systemConfig['invoice.is_paper_invoice_post_enable']
			},
			isSceneEnable() {
				return this.$store.state.systemConfig['invoice.is_paper_invoice_scene_enable']
			},
			isPostOnly() {
				if (!this.isSceneEnable && this.isPostEnable) {
					this.ruleForm.paper_get_invoice_method = 'post'
					return true
				}
				return false
			},
			isSceneOnly() {
				if (this.isSceneEnable && !this.isPostEnable) {
					this.ruleForm.paper_get_invoice_method = 'scene'
					return true
				}
				return false
			},
			queryOrderNo() {
				if (this.$route.query.order_no) {
					return Array.isArray(this.$route.query.order_no) ? this.$route.query.order_no : [this.$route.query.order_no]
				} else {
					return []
				}
			},
			OilTypes() {
				return this.$store.state.systemEnum.oil_type || []
			},
			displaySiteName() {
				let site = this.quotaInfo.find((item) => item.id === this.ruleForm.site_id)
				return (site && site.name + `(可开额度: ${this.maxQuota})`) || ''
			},
			displayOilName() {
				let type = this.OilTypes.find((item) => item.id === this.ruleForm.oil_type_id)
				return (type && type.name) || ''
			},
            displayInvoiceOrderType(){
                let type = this.invoiceOrderTypeArr.find((item) => item.id === this.ruleForm.invoice_order_type)
                return (type && type.name) || ''
            },
			quotaInfoWithMax() {
				if (!this.quotaInfo) return ''
                return this.quotaInfo.map((item, index, ary) => {
					return {
						...item,
						text: item.name + `(可开额度: ${item.quota})`
					};
				})
			},
            invoiceOrderTypeArr(){
                let invoice_order_type = this.$store.state.systemEnum && this.$store.state.systemEnum.company.invoice_order.invoice_type || {};
                let isQuotaInvoice = this.queryOrderNo.length <= 0;  // 是否是额度开票
                let current_site_id = this.ruleForm.site_id;
                let siteAllowInvoiceTypeArr = this.siteAllowInvoiceTypeArr;
                let arr = [];
                for (let key in invoice_order_type) {
                    let disabled = false;
                    if(isQuotaInvoice){
                        disabled = siteAllowInvoiceTypeArr[current_site_id].indexOf(key) === -1;
                    }else{
                        disabled = this.allowInvoiceTypeArr.indexOf(key) === -1;
                    }
                    arr.push({
                        id : key,
                        name: invoice_order_type[key],
                        disabled: disabled,
                    });
                }
                return arr;
            },
		},
        methods : {
			setReceiveArea(data) {
				this.showArea = false;
				this.ruleForm.receive_province = data[0].name || '';
				this.ruleForm.receive_city = data[1].name || '';
				this.ruleForm.receive_district = data[2].name || '';
			},

			setSite(data) {
				this.showSite = false;
				this.ruleForm.site_id = data.id || '';
				this.ruleForm.total_amount = data.quota || 0;
				this.maxQuota = data.quota;
                this.ruleForm.invoice_order_type = '';   // 重新选择开票种类
			},

			setOil(data) {
				this.showOil = false;
				this.ruleForm.oil_type_id = data.id || '';
			},
            setInvoiceOrderType(data){
                this.showInvoiceOrderType = false;

                if(data.disabled) return;
                this.ruleForm.invoice_order_type = data.id || '';
            },

			validatorAmount(val, rule) {
				if (!this.ruleForm.site_id) return false
				const maxQuotaNum = typeof this.maxQuota === 'string' ? Number(this.maxQuota) : this.maxQuota
				const valNum = typeof val === 'string' ? Number(val) : val
				return maxQuotaNum >= valNum ? true : false
			},

			validatorAmountMsg(val, rule) {
				if (!this.ruleForm.site_id) return '请选择站点'
				return `金额${val}大于该站点额度最大值${this.maxQuota}`
			},

            send(){
				if (!this.ruleForm.order_no) {
					this.$dialog.alert({
						message: '读取订单失败,请重新选择订单进行申请'
					}).then(() => {
						self.$router.back()
					})
					return
				}
                let self = this;
                if (this.isLoading) return;
                this.isLoading = true;
                let loading = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
				api.request('/invoice/invoice', self.ruleForm).then(res => {
					self.$toast.clear();
					this.$dialog({
						message: res.msg
					}).then(() => {
						self.$router.back()
					})
				}).catch(res => {
					self.$toast.clear();
					this.$dialog({
						message: res.msg
					})
				}).finally(() => {
					self.isLoading = false;
				});
            },

            onRefresh () {
                if (this.requestIsLock) return
                // 刷新则初始化页数
                this.finished = false
                this.refreshLoading = true;
                this.params.page = 1
                this.getInvoiceList()
            },

			// 列表滚动加载
            onLoad () {
                if (this.requestIsLock) return
                this.getInvoiceList()
            },

            getInvoiceList () {
                let loading = this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                    duration: 0,
                });
                // 关锁
                this.requestIsLock = true;
				const that = this
                api.request('/user_invoice_info/list', {
                    page: this.params.page,
                    page_size: this.params.pageSize,
                }).then(res => {
                    if (that.refreshLoading) {
                        that.invoiceList = []
                        that.refreshLoading = false
                    }
                    // 数据不为空则页数加一，并添加数据至末尾
                    if (!!res.data.data.length) {
                        that.params.page++
                        that.invoiceList = this.invoiceList.concat(res.data.data)
                    }
                    // 判断是否还有数据
                    if (that.invoiceList.length >= res.data.total) {
                        that.finished = true
                    }
					console.log(that.refreshLoading, that.invoiceList)
                }).finally(() => {
					that.listLoading = false
                    that.$toast.clear(loading);
                    // 开锁
                    that.requestIsLock = false
                })
            },

			settingInvoiceTitle(item) {
				const keys = Object.keys(this.ruleForm);
				for (const itemKey in item) {
					keys.indexOf(itemKey) > -1 ? this.ruleForm[itemKey] = item[itemKey] : false
				}
				this.setTitle = false;
			},

			disableMsg() {
				if (this.isElectronOnly) {
					this.$toast('暂不支持纸质发票');
				} else if (this.isPaperOnly) {
					this.$toast('暂不支持电子发票');
				}
			},

			disableMethodMsg() {
				if (this.isSceneOnly) {
					this.$toast('暂不支持邮寄纸质发票');
				} else if (this.isPostOnly) {
					this.$toast('暂不支持现场获取纸质发票');
				}
			},
            typeChange(){
                let prevType = this.ruleForm.type === 'company' ? 'personal' : 'company';
                let currentType = this.ruleForm.type;
                this.cacheTypeInfo[prevType] = {
                    name: this.ruleForm.name,
                    taxpayer_no: this.ruleForm.taxpayer_no,
                    business_address: this.ruleForm.business_address,
                    business_telephone: this.ruleForm.business_telephone,
                    bank_of_deposit: this.ruleForm.bank_of_deposit,
                    bank_account: this.ruleForm.bank_account,
                };
                let currentCache = this.cacheTypeInfo[currentType];
                if(currentCache){
                    this.ruleForm.name = currentCache.name;
                    this.ruleForm.taxpayer_no = currentCache.taxpayer_no;
                    this.ruleForm.business_address = currentCache.business_address;
                    this.ruleForm.business_telephone = currentCache.business_telephone;
                    this.ruleForm.bank_of_deposit = currentCache.bank_of_deposit;
                    this.ruleForm.bank_account = currentCache.bank_account;
                }else{
                    this.ruleForm.name = '';
                    this.ruleForm.taxpayer_no = '';
                    this.ruleForm.business_address = '';
                    this.ruleForm.business_telephone = '';
                    this.ruleForm.bank_of_deposit = '';
                    this.ruleForm.bank_account = '';
                }
            },
        },
		watch: {
		}
    }
</script>

<style lang="scss" scoped>

	.show {
    	animation: 0.5s linear 0s normal show-form;
		overflow: hidden;
	}

	.hidden {
    	animation: 0.5s linear 0s normal hidden-form;
		overflow: hidden;
	}

	@keyframes show-form {
		0% {
			max-height: 0;
		}
		100% {
			max-height: 500px;
		}
	}

	@keyframes hidden-form {
		0% {
			max-height: 500px;
		}
		100% {
			max-height: 0px;
		}
	}

	.invoice-detail {
		margin: 10px;
		background: #fff;
		.page-title {
			padding: 0.4rem;
			font-size: 0.5rem;
			font-weight: bolder;
		}

		.required {
			&::before {
				position: absolute;
				left: 0.21333rem;
				color: #ee0a24;
				font-size: 0.37333rem;
				content: '*';
			}
		}

		.title {
			color: #333;
			font-size: 15px;
			font-weight: bold;
		}

		.field {
			padding: 0px;
			font-size: 14px;
			font-weight: lighter;
		}

		.SubmitBtn {
			margin: 0;
			width: 75vw;
		}

		.switch-text {
			font-weight: lighter;
			font-size: 14px;
			line-height: 24px;
			margin: 0 5px;
			color: #333;
		}
	}

	.set-title{
		height: 80%;
		.invoice_list-container{

			.invoice-item-container {
				margin: 10px;
				border-radius: 10px;
				background: #ffffff;
				box-shadow: 0 0 5px 0 rgba(0, 0, 0, .05);
				overflow: hidden;
				border: #ccc solid 0.1px;

				.invoice-item-headline {
					span {
						display: block;
						font-size: 16px;
						color: #333;
					}

					.sub-title {
						font-size: 12px;
						color: #bbb;
					}
				}
			}
		}
	}

</style>



// WEBPACK FOOTER //
// src/pages/invoice/Invoice.vue